import script from "./PlanCardModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PlanCardModal.vue?vue&type=script&setup=true&lang=js"

import "./PlanCardModal.vue?vue&type=style&index=0&id=5521a976&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5521a976"]])

export default __exports__